import { getDetailsTabRoutes, getDetailsTabRouteObjects, getSelectableResult } from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const invoiceListLDTRoutes = getDetailsTabRoutes('invoices', 'invoice_id');
export const invoiceReminderListLDTRoutes = getDetailsTabRoutes('invoice_reminders', 'invoice_reminder_id');

export const getInvoiceDetailsSelectable = getSelectableResult(invoiceListLDTRoutes);
export const getInvoiceReminderDetailsSelectable = getSelectableResult(invoiceReminderListLDTRoutes);

export const costListLDTRoutes = getDetailsTabRoutes('costs', 'invoice_id');

export const getCostDetailsSelectable = getSelectableResult(costListLDTRoutes);

export const moduleRoutes = [
  invoiceListLDTRoutes,
  invoiceReminderListLDTRoutes,
  costListLDTRoutes,
];


const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
}